import React from 'react';
import { useParams, Link } from 'react-router-dom';

const ConfirmationPage = () => {
  const { referenceId } = useParams();

  return (
    <div className="max-w-3xl mx-auto text-center">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <div className="text-green-500 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-primary mb-4">Report Submitted Successfully</h1>

        <p className="text-lg mb-6">
          Thank you for submitting your report. We have received your information and will review it shortly.
        </p>

        <div className="bg-gray-100 p-4 rounded-md inline-block mb-8">
          <p className="text-sm text-gray-500">Your Reference ID</p>
          <p className="text-2xl font-bold text-primary">{referenceId}</p>
        </div>

        <div className="space-y-4">
          <p>
            Please save this reference ID for your records. You can use it to follow up on your report in the future.
          </p>

          <p>
            You will receive an email confirmation at the address you provided with further instructions and updates.
          </p>
        </div>

        <div className="mt-8">
          <Link to="/" className="btn-primary">
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
